import { Classifiers } from '../../contexts/ClassifiersContext/ClassifiersContext.types';
import { Classifier } from '../../generated/model/models';
import { httpClient } from '../config/httpClient';

const path = {
  get: '/classifiers',
};

export const getClassifiers = async (): Promise<Classifiers> => {
  const response = await httpClient.get<Classifier[]>(path.get);
  return formatClassifiers(response.data);
};

function formatClassifiers(classifiers: Classifier[] = []): Classifiers {
  return classifiers.reduce((data: any, classifier: Classifier) => {
    if (classifier.id && classifier.values) {
      data[classifier.id] = removeEmptyValues(classifier.values);
    }

    return data;
  }, {});
}

function removeEmptyValues(classifiers: Classifier[]): Classifier[] {
  return classifiers.map((classifier: Classifier) => {
    if (!Array.isArray(classifier.values)) {
      return classifier;
    }

    if (!classifier.values.length) {
      delete classifier.values;
    } else {
      classifier.values = removeEmptyValues(classifier.values);
    }

    return classifier;
  });
}
